import React from "react";

export const NotFoundPage = () => <p>Página no encontrada</p>;
